"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    media: {
        height: 350,
        width: '50%',
        [theme.breakpoints.down('lg')]: {
            height: 290
        },
        [theme.breakpoints.down('md')]: {
            height: 282
        },
        [theme.breakpoints.down('xs')]: {
            height: 350,
            width: '100%'
        }
    },
    card: {
        height: '100%',
        position: 'relative',
        margin: '32px 0px'
    },
    cardMultiple: {
        height: '100%',
        position: 'relative',
        margin: '32px 16px'
    },
    parentDiv: { position: 'relative' },
    overlay40: {
        filter: 'brightness(0.6)'
    },
    img: {
        height: 350,
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            height: 300
        }
    },
    cardContent: {
        width: '50%',
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        }
    },
    cardAction: {
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column'
        }
    },
    cardDetails: {
        display: 'flex',
        flexDirection: 'row'
    },
    cardDetailsCell: {
        flexBasis: '50%'
    },
    spacing: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginBottom: theme.spacing(3)
    },
    spacingTop: {
        marginTop: theme.spacing()
    },
    maxJackpotText: {
        position: 'absolute',
        top: '91%',
        right: '50%',
        width: 'inherit',
        [theme.breakpoints.down('sm')]: {
            top: '88%'
        },
        [theme.breakpoints.down('xs')]: {
            top: '96%',
            right: '0%'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=ProgressiveCardStyles.js.map